module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/promo/mobile-vide-preview-ed4218de1d16ace8c4e7c98cfc794dc4.jpg";